import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface TableCardProps {
  children: ReactNode;
  className?: string;
}

export function TableCard({
  children,
  className,
}: TableCardProps): JSX.Element {
  return (
    <Card
      className={cn(
        "overflow-hidden dark:border-border/80 dark:shadow-md dark:shadow-black/15",
        className,
      )}
    >
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
}
